import DataModel from '@ember-data/model';
import {
  FilterId,
  FilterOptionsType,
  MultiSelectFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export class PropertyFilter extends MultiSelectFilter<
  ModelRegistry['property']
> {
  id = FilterId.property;
  optionsType = FilterOptionsType.store;
  modelName = 'property';
  modelField = 'nickname' as keyof DataModel;
}
